import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'subscription/trial',
  async getComponent (nextState) {
    const {
      default: SubscriptionContainer
    } = await import(/* webpackChunkName: "pages-container" */ './components/SubscriptionContainer.tsx')
      .catch(handleChunkLoadError);
    return SubscriptionContainer;
  }
});
